import { Table } from "react-bootstrap";
import { useBoundaries } from "../../../context/boundary";
import { useCallback } from "react";
import { getMileageCssVar } from "../../../theme/mileageRanges";

interface MileageTableProps {
  year?: number;
}

const MileageTable = ({ year }: MileageTableProps) => {
  const { selectedBoundary: boundary, measurementMode } = useBoundaries();

  const records = boundary?.mileageRecords ?? [];

  const formatPercent = (p: number | null) =>
    p == null ? "—" : `${p.toFixed(1)}%`;

  const getDistance = useCallback(
    (distance: number | null) => {
      if (distance == null) return "—";

      const converted =
        measurementMode === "mi" ? Math.round(distance * 0.621371) : distance;
      return converted.toLocaleString();
    },
    [measurementMode],
  );

  return (
    <Table size="sm" striped bordered hover responsive className="m-0">
      <thead>
        <tr>
          <th>Year</th>
          <th>Distance</th>
          <th>% Change since 2021</th>
        </tr>
      </thead>
      <tbody>
        {records.length === 0 ?
          <tr>
            <td colSpan={3}>No records</td>
          </tr>
        : records.map((r, idx) => {
            return (
              <tr
                key={`${r.year ?? "null"}-${idx}`}
                style={
                  r.year === year ?
                    {
                      fontWeight: 800,
                    }
                  : undefined
                }
              >
                <td>{r.year ?? "—"}</td>
                <td className="text-end">{getDistance(r.mileage)}</td>
                <td
                  className="text-center"
                  style={{ position: "relative", paddingRight: "18px" }}
                >
                  {formatPercent(r.percentageChange)}
                  {idx > 0 && r.percentageChange != null && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        width: "10px",
                        height: "100%",
                        backgroundColor: getMileageCssVar(r.percentageChange),
                      }}
                    />
                  )}
                </td>
              </tr>
            );
          })
        }
      </tbody>
    </Table>
  );
};

export default MileageTable;
